import React, { useState } from 'react';
import BotDetailsModal from './BotDetailsModal';
import '../../styles/dashboard/BotReplyCard.css';
import { Search } from "lucide-react";

function BotReplyCard({ reply }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getBotTypeLabel = (botType) => {
    switch(botType) {
      case 'BOT': return 'בוט';
      case 'LIKELY_BOT': return 'סביר שבוט';
      case 'SUSPICIOUS': return 'חשוד';
      default: return 'לא ידוע';
    }
  };

  return (
    <>
      <div className="bot-reply-card">
        {/* Header */}
        <div className="bot-reply-header">
          <div className="bot-reply-user">
            <img 
              src={reply.profile_image_url || 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png'} 
              alt={reply.username}
              className="bot-reply-avatar"
            />
            <div className="bot-reply-info">
              <div className="bot-reply-name">{reply.name}</div>
              <div className="bot-reply-username">@{reply.username}</div>
            </div>
          </div>
          
          <div className="bot-reply-score-container">
            <div className="bot-reply-score">
              {reply.bot_score}/100
            </div>
            
            <button className="why-bot-btn" onClick={() => setIsModalOpen(true)}>
              למה בוט?
              <Search size={14} color="#ffffff" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="bot-reply-content">
          <p>{reply.text}</p>
        </div>

        {/* Footer */}
        <div className="bot-reply-footer">
          <span className="bot-type-badge">
            🤖 {getBotTypeLabel(reply.bot_type)}
          </span>
          <span className="bot-followers">
            👥 {reply.followers_count?.toLocaleString() || 0} עוקבים
          </span>
        </div>
      </div>

      <BotDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        userId={reply.author_twitter_id}
      />
    </>
  );
}

export default BotReplyCard;